// @flow

import { logger } from '../../../common'

import { createMetricEvent } from '../../../common/api/chatchampApi'

import {
  CHATBOT_EVENTS,
  type WelcomeMessageClickEventPayload,
  type OpenChatClickEventPayload
} from '../types'

function createMessageClickMetricEvent (eventPayload: WelcomeMessageClickEventPayload) {
  createMetricEvent(eventPayload.customerId, eventPayload.subscriberId, 'activation', 'welcome_message_click', {
    welcomeMessageId: eventPayload.welcomeMessageId,
    device: eventPayload.device,
    welcomeMessageBubbleClick: eventPayload.welcomeMessageBubbleClick
  }).catch((error) => logger.error(error))
}

function createOpenChatClickMetricEvent (eventPayload: OpenChatClickEventPayload) {
  createMetricEvent(eventPayload.customerId, eventPayload.subscriberId, 'activation', 'open_chat_click', {
    welcomeMessageId: eventPayload.welcomeMessageId,
    device: eventPayload.device
  }).catch((error) => logger.error(error))
}

export function registerMetricEventListeners (): void {
  window.addEventListener(CHATBOT_EVENTS.WelcomeMessageClick, ({ detail }) => createMessageClickMetricEvent(detail))
  window.addEventListener(CHATBOT_EVENTS.OpenChatClick, ({ detail }) => createOpenChatClickMetricEvent(detail))
}
